// src/components/Admin/Dashboard/VolunteersModal.tsx

import React, { useEffect, useState } from "react";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Paper,
} from "@mui/material";
import { volunteerService } from "../../../services/api/volunteerService";
import { Volunteer } from "../../../types/volunteer";
import DetailsModal from "./DetailsModal";

interface VolunteersModalProps {
  open: boolean;
  onClose: () => void;
  token: string;
}

const VolunteersModal: React.FC<VolunteersModalProps> = ({ open, onClose, token }) => {
  const [volunteers, setVolunteers] = useState<Volunteer[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      const fetchVolunteers = async () => {
        setLoading(true);
        setError(null);
        try {
          const response = await volunteerService.getVolunteers(token);
          console.log('Volunteers response:', response);
          
          // Handle different response formats
          if (Array.isArray(response)) {
            setVolunteers(response);
          } else if (response && 'volunteers' in response && Array.isArray(response.volunteers)) {
            setVolunteers(response.volunteers);
          } else {
            console.warn("Unexpected volunteer data format:", response);
            setError("Invalid response format from server");
          }
        } catch (err: any) {
          setError(err.message || "An error occurred while fetching volunteers.");
        } finally {
          setLoading(false);
        }
      };

      fetchVolunteers();
    }
  }, [open, token]);

  return (
    <DetailsModal open={open} onClose={onClose} title="All Volunteers">
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : volunteers.length === 0 ? (
        <Typography>No volunteers available.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="volunteers table">
            <TableHead>
              <TableRow>
                <TableCell>Volunteer ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {volunteers.map((volunteer) => (
                <TableRow key={volunteer.id}>
                  <TableCell>{volunteer.id}</TableCell>
                  <TableCell>{volunteer.name}</TableCell>
                  <TableCell>{volunteer.email}</TableCell>
                  <TableCell>{volunteer.phone || "N/A"}</TableCell>
                  <TableCell>{new Date(volunteer.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DetailsModal>
  );
};

export default VolunteersModal;
